var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8475_1542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 33.5929H33.3337V23.5929L21.667 11.9263C25.3991 10.1438 29.592 9.56229 33.6683 10.2617C37.7446 10.9611 41.5039 12.907 44.4284 15.8315C47.3529 18.756 49.2989 22.5153 49.9983 26.5916C50.6976 30.6679 50.1161 34.8608 48.3337 38.5929L68.3337 58.5929C69.6597 59.919 70.4047 61.7176 70.4047 63.5929C70.4047 65.4683 69.6597 67.2669 68.3337 68.5929C67.0076 69.919 65.209 70.664 63.3337 70.664C61.4583 70.664 59.6597 69.919 58.3337 68.5929L38.3337 48.5929C34.6016 50.3754 30.4087 50.9569 26.3323 50.2575C22.256 49.5581 18.4968 47.6122 15.5722 44.6877C12.6477 41.7632 10.7018 38.0039 10.0024 33.9276C9.30301 29.8513 9.88457 25.6584 11.667 21.9263L23.3337 33.5929Z",
    stroke: "#BF4036",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8475_1542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.259766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpana);
export default __webpack_public_path__ + "static/media/spana.0bc5b4063717cba6601456c06536d42f.svg";
export { ForwardRef as ReactComponent };